import { render, staticRenderFns } from "./aws-ebs.vue?vue&type=template&id=036dad2d&"
import script from "./aws-ebs.vue?vue&type=script&lang=js&"
export * from "./aws-ebs.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports